/**
 * The CustomsFieldPro logo.
 *
 * One component so the mark stays identical everywhere. It was previously
 * drawn four different ways — a house outline in the CRM sidebar, a green
 * tick on the login page, and a letter "C" twice in the platform panel — none
 * of which matched the icon people see on their home screen.
 *
 * Serves /apple-touch-icon.png, the same file used for the favicon and the
 * installed app icon, so the three can never drift apart.
 */
export default function BrandMark({ size = 32, radius, style }) {
  return (
    <img
      src="/apple-touch-icon.png"
      alt="CustomsFieldPro"
      width={size}
      height={size}
      style={{
        width: size,
        height: size,
        borderRadius: radius ?? Math.round(size * 0.22),
        flexShrink: 0,
        display: 'block',
        objectFit: 'cover',
        ...style,
      }}
    />
  )
}
